import type { ErrorMessage } from 'domains/order';

export const hasError = (error: unknown) => {
  const status = (error as ErrorMessage)?.status.toString() || '';

  return status.includes('30') || status.includes('40') || status.includes('50');
};
